import { not_implemented_type } from '@shared/asserts/utils_asserts';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { GRID2D_generation_current } from '../views_with_data/generation_current/GRID2D_generation_current';
import { GRID2D__collection } from '../views_with_data/GRID2D__collection';
import { GRID2D__user_task } from '../views_with_data/GRID2D__user_task';
import { ViewGrid2dSearchCurrent } from '../views_with_data/ViewGrid2dSearchCurrent';

interface Props {
  entity_type: string;
  entity_id: string;
}

export function GRID2D__master({ entity_id, entity_type }: Props) {
  /*
   * METHODS
   */

  /*
   * RENDERS
   */

  function render_view() {
    let out = <></>;

    switch (entity_type) {
      case ENUM__workspace_entity.COLLECTION_CUSTOM:
      case ENUM__workspace_entity.COLLECTION_FAVORITES:
      case ENUM__workspace_entity.COLLECTION_UPLOADS:
      case ENUM__workspace_entity.COLLECTION_GENERATED:
      case ENUM__workspace_entity.COLLECTION_VIEWED_ON_SEARCH:
        out = <GRID2D__collection entity_id={entity_id} entity_type={entity_type} />;
        break;

      case ENUM__workspace_entity.ENTITY_SEARCH:
        out = <ViewGrid2dSearchCurrent />;
        break;
      case ENUM__workspace_entity.ENTITY_USER_TASK:
        out = <GRID2D__user_task {...{ entity_id }} />;
        break;
      case ENUM__workspace_entity.ENTITY_GENERATION:
        out = <GRID2D_generation_current />;
        break;
      default:
        not_implemented_type(entity_type);
    }

    return out;
  }

  return render_view();
}
